// 邮局派送重算
export const COLLECTING_DISPATCH_OBJ = {
  reCalculatePriceSource: 0, // 重算类型 0 查询结果 1 勾选结果 2 导入数据 3 导入重量数据
  ids: [], // 勾选数据id
  importDataList: [] // 导入数据
};
